
import { SaleLayoutLogoPosition } from "@/utils/sale-layouts/logo";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		fancy: Boolean,
		label: String,
		value: String as () => SaleLayoutLogoPosition,
		includeNone: Boolean,
		fullControl: Boolean,
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		disabled: Boolean
	},
	computed: {
		items(): ISelectItem<SaleLayoutLogoPosition | "null">[] {
			let result: ISelectItem<SaleLayoutLogoPosition | "null">[] = [];
			if (this.includeNone) {
				result = [{
					text: this.$ct("notPlaced").toString(),
					value: "null"
				}];
			}
			result.push({
				text: this.$ct("header").toString(),
				value: "Heading"
			});
			if (this.fullControl) {
				result.push(
					{
						text: this.$ct("body").toString(),
						value: "Body"
					},
					{
						text: this.$ct("footer").toString(),
						value: "Footer"
					},
					{
						text: this.$ct("components.sale-layout-editor.requirements").toString(),
						value: "Requirements"
					}
				);

				result.push(...this.beforeFreeLineItems);
				result.push(...this.afterFreeLineItems);
				result.push(...this.aboveTableFreeLineItems);
			}
			return result;
		},
		beforeFreeLineItems():ISelectItem<SaleLayoutLogoPosition>[] {
			return this.layout.FreeLines.filter(f=>f.Placement == "Totals").map((f,i)=>{
				return {
					text: this.$ct("free-line-in-total-num", {num: i+1}),
					value: f.Key
				} as ISelectItem<SaleLayoutLogoPosition>;
			});
		},
		afterFreeLineItems():ISelectItem<SaleLayoutLogoPosition>[] {
			return this.layout.FreeLines.filter(f=>f.Placement == "AfterDetail").map((f,i)=>{
				return {
					text: this.$ct("free-line-after-details-num", {num: i+1}),
					value: f.Key
				} as ISelectItem<SaleLayoutLogoPosition>;
			});
		},
		aboveTableFreeLineItems():ISelectItem<SaleLayoutLogoPosition>[] {
			return this.layout.FreeLines.filter(f=>f.Placement == "AboveTable").map((f,i)=>{
				return {
					text: this.$ct("free-line-above-table-num", {num: i+1}),
					value: f.Key
				} as ISelectItem<SaleLayoutLogoPosition>;
			});
		}
	},
	methods: {
		onInput(value: SaleLayoutLogoPosition | "null") {
			this.$emit("input", value);
		}
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
